module.exports = __webpack_public_path__ + "img/hero.d217d28d.png";